export class AppKeyApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getAllAppKeys(companyId) {
    return this.#http.get('/api/app-keys', { params: { companyId } });
  }

  async getAppKey(id) {
    return this.#http.get(`/api/app-keys/${id}`);
  }

  async createAppKey(appKeyData) {
    return this.#http.post('/api/app-keys', appKeyData);
  }

  async updateAppKey(id, appKeyData) {
    return this.#http.put(`/api/app-keys/${id}`, appKeyData);
  }

  async deleteAppKey(id) {
    return this.#http.delete(`/api/app-keys/${id}`);
  }
}
